module.exports = __webpack_public_path__ + "41b7123a1d0564723384caf30493028b.MP3";